import {
	CardActions,
	CardContent,
	CardHeader,
	Typography,
} from "@material-ui/core";
import React from "react";
import { Card } from "../../../common/MaterialComponent";
import { ButtonPrimary } from "../../../common/sharedStyle";
import "../TemplateLibraryViewPage.css";

interface TemplateCardProps {
	header: string;
	body: string;
	cardButtonText: string;
	cardButtonAction: () => void;
	disableCardButton: boolean;
}

export default function TemplateCard(props: TemplateCardProps) {
	return (
		<Card elevation={2} className="templateCardContainer">
			<CardHeader title={props.header} className="templateCardHeader" />
			<CardContent>
				<Typography
					variant="body2"
					color="textSecondary"
					component="p"
					className="templateCardBody"
				>
					{props.body}
				</Typography>
			</CardContent>
			<CardActions className="templateCardActions">
				<ButtonPrimary
					onClick={props.cardButtonAction}
					className={
						props.disableCardButton ? "templateCardButtonDisabled" : ""
					}
					disabled={props.disableCardButton}
				>
					{props.cardButtonText}
				</ButtonPrimary>
			</CardActions>
		</Card>
	);
}
